var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExperienceDetails = function SvgExperienceDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 89,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 89,
    rx: 8,
    fill: "#F4F5F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#experience_details_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 159,
    height: 69,
    rx: 5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14a4 4 0 0 1 4-4h151a4 4 0 0 1 4 4v31H10V14Z",
    fill: "#97BBFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 51,
    width: 22,
    height: 22,
    rx: 2,
    fill: "#EAF1FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.25,
    y: 56,
    width: 13.5,
    height: 12,
    rx: 2,
    stroke: "#4467F6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4467F6",
    strokeWidth: 2,
    d: "M21 60.25h12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 58.25,
    r: 0.75,
    fill: "#4467F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.75,
    cy: 58.25,
    r: 0.75,
    fill: "#4467F6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 58.25,
    r: 0.75,
    fill: "#4467F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 51,
    width: 42.929,
    height: 9,
    rx: 2,
    fill: "#EAF1FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 64,
    width: 119,
    height: 9,
    rx: 2,
    fill: "#EAF1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "experience_details_svg__a",
    x: 6,
    y: 7,
    width: 167,
    height: 77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.180392 0 0 0 0 0.25098 0 0 0 0 0.345098 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1342_56589"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1342_56589",
    result: "shape"
  })))));
};

export default SvgExperienceDetails;